





























































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import FilterMenu from './Components/FilterMenu.vue'
import FilterTablePowerUser from './Components/FilterTablePowerUser.vue'
import CardMenu from './Components/CardMenu.vue'
import BarChart from './Components/BarChart/BarChart.vue'
import LineChart, { ILineChartData } from './Components/LineChart/LineChart.vue'
import TableMenu from './Components/TablesMenu.vue'
import TableDealer from './Components/TableDealer.vue'
import { UserReportModule } from '@/app/store/modules/userReport'
import { UserModule } from '@/app/store/modules/user'
import { AuthModule } from '@/app/store/modules/auth'
import { UserActiveData } from '../../../../../domain/entities/Dashboard'

@Component({
  name: 'UserReports',
  components: {
    'top-menu': TopMenu,
    'filter-menu': FilterMenu,
    'card-menu': CardMenu,
    'bar-chart': BarChart,
    'line-chart': LineChart,
    'table-menu': TableMenu,
    'table-dealer': TableDealer,
    'filter-table-power-user': FilterTablePowerUser,
  },
})
export default class extends Vue {
  public searchValue: string = ''

  public created() {
    UserReportModule.paginationParam.filter.salescode = ''
    UserReportModule.paginationParam.filter.team = ''
    UserReportModule.paginationParam.filter.position = ''
    UserReportModule.paginationParam.filter.dealercode = ''
    UserReportModule.paginationParam.filter.dealergroup = ''
    UserReportModule.paginationParam.filter.active = ''
    UserReportModule.paginationParam.filter.statusRegistration = ''
    UserReportModule.paginationParam.filter.typeSales = ''
    UserReportModule.paginationParam.filter.dealerarea = ''
    UserReportModule.paginationParam.filter.dealername = ''
    UserReportModule.paginationParam.filter.city = ''
    UserReportModule.paginationParam.filter.branch = ''
    UserReportModule.paginationParam.filter.start = ''
    UserReportModule.paginationParam.filter.end = ''
    this.getUserData()
    this.getExport()
  }
  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }
  public get isLoading(): boolean {
    return UserReportModule.isLoading
  }
  public get getUserData(): any {
    return UserReportModule.getUserData
  }
  public get TopMenu(): any {
    return UserReportModule.userData.topMenu
  }
  public get PktData(): any {
    return UserReportModule.userData.pktData
  }
  public get dataCharts(): any {
    return UserReportModule.userData.chart
  }
  public get dataAccessRateCharts(): any {
    return UserReportModule.userData.accessRateCharts
  }
  public get UserActiveData(): any {
    return UserReportModule.userData.userActive
  }
  public get MaterialAcess(): any {
    return UserReportModule.userData.materialAccess
  }
  public getExport() {
    UserModule.getExportData()
  }
  public get isLoadingExport() {
    return UserModule.isLoadingExport
  }
  public get linkExport() {
    return UserModule.exportData.data
  }

  // Property Top Menu
  private funcSearch(item) {
    this.clearFilter()
    UserReportModule.paginationParam.filter.team = ''
    UserReportModule.paginationParam.filter.position = ''
    UserReportModule.paginationParam.filter.dealercode = ''
    UserReportModule.paginationParam.filter.dealergroup = ''
    UserReportModule.paginationParam.filter.active = ''
    UserReportModule.paginationParam.filter.statusRegistration = ''
    UserReportModule.paginationParam.filter.typeSales = ''
    UserReportModule.paginationParam.filter.dealerarea = ''
    UserReportModule.paginationParam.filter.dealername = ''
    UserReportModule.paginationParam.filter.city = ''
    UserReportModule.paginationParam.filter.branch = ''
    UserReportModule.paginationParam.filter.start = ''
    UserReportModule.paginationParam.filter.end = ''
    UserReportModule.paginationParam.filter.salescode = item
    UserModule.paginationParamsExport.filter.team = ''
    UserModule.paginationParamsExport.filter.position = ''
    UserModule.paginationParamsExport.filter.dealercode = ''
    UserModule.paginationParamsExport.filter.dealergroup = ''
    UserModule.paginationParamsExport.filter.active = ''
    UserModule.paginationParamsExport.filter.statusRegistration = ''
    UserModule.paginationParamsExport.filter.typeSales = ''
    UserModule.paginationParamsExport.filter.team = ''
    UserModule.paginationParamsExport.filter.dealerarea = ''
    UserModule.paginationParamsExport.filter.dealername = ''
    UserModule.paginationParamsExport.filter.dealerCity = ''
    UserModule.paginationParamsExport.filter.dealerBranch = ''
    UserModule.paginationParamsExport.search = item
    this.searchValue = item
    this.getUserData()
    this.getExport()
  }

  private funcFilter(data) {
    this.clearInputSearch()
    // console.log('data funcfilter' + data.byPosition3)
    UserReportModule.paginationParam.filter.salescode = ''
    UserReportModule.paginationParam.filter.team = data.team
    UserReportModule.paginationParam.filter.position = data.byPosition3
    UserReportModule.paginationParam.filter.dealercode = data.dealercode
    UserReportModule.paginationParam.filter.dealergroup = data.dealergroup.split(
      '/'
    )[0]
    UserReportModule.paginationParam.filter.active = data.active
    UserReportModule.paginationParam.filter.statusRegistration =
      data.statusRegistration
    UserReportModule.paginationParam.filter.typeSales = data.typeSales
    UserReportModule.paginationParam.filter.dealerarea = data.dealerarea
    UserReportModule.paginationParam.filter.dealername = data.dealername.split(
      '/'
    )[1]
    UserReportModule.paginationParam.filter.city = data.city
    UserReportModule.paginationParam.filter.branch = data.dealerBranch.split(
      '/'
    )[1]
    UserReportModule.paginationParam.filter.start = data.filterDate[0]
    UserReportModule.paginationParam.filter.end = data.filterDate[1]
    UserModule.paginationParamsExport.filter.position = data.byPosition3
    UserModule.paginationParamsExport.filter.dealername = data.dealername.split(
      '/'
    )[1]
    UserModule.paginationParamsExport.filter.dealerarea = data.dealerarea
    UserModule.paginationParamsExport.filter.team = data.team
    UserModule.paginationParamsExport.filter.dealercode = data.dealercode
    UserModule.paginationParamsExport.filter.dealerCity = data.cityId
    UserModule.paginationParamsExport.filter.dealerBranch = data.dealerBranch.split(
      '/'
    )[1]
    UserModule.paginationParamsExport.filter.dealergroup = data.dealergroup.split(
      '/'
    )[0]
    UserModule.paginationParamsExport.filter.active = data.active
    if (data.typeSales === 'sfd') {
      UserModule.paginationParamsExport.filter.type = 'sfid'
    } else {
      UserModule.paginationParamsExport.filter.type = 'Dnet'
    }
    UserModule.paginationParamsExport.filter.statusRegistration =
      data.statusRegistration
    UserModule.paginationParamsExport.search = ''
    this.getUserData()
    this.getExport()
  }

  private funcClearFilter() {
    this.clearInputSearch()
    this.clearFilter()
    UserReportModule.paginationParam.filter.salescode = ''
    UserReportModule.paginationParam.filter.team = ''
    UserReportModule.paginationParam.filter.position = ''
    UserReportModule.paginationParam.filter.dealercode = ''
    UserReportModule.paginationParam.filter.dealergroup = ''
    UserReportModule.paginationParam.filter.active = ''
    UserReportModule.paginationParam.filter.statusRegistration = ''
    UserReportModule.paginationParam.filter.typeSales = ''
    UserReportModule.paginationParam.filter.dealerarea = ''
    UserReportModule.paginationParam.filter.dealername = ''
    UserReportModule.paginationParam.filter.city = ''
    UserReportModule.paginationParam.filter.branch = ''
    UserReportModule.paginationParam.filter.start = ''
    UserReportModule.paginationParam.filter.end = ''
    UserModule.paginationParamsExport.filter.position = ''
    UserModule.paginationParamsExport.filter.dealercode = ''
    UserModule.paginationParamsExport.filter.dealergroup = ''
    UserModule.paginationParamsExport.filter.active = ''
    UserModule.paginationParamsExport.filter.statusRegistration = ''
    UserModule.paginationParamsExport.filter.typeSales = ''
    UserModule.paginationParamsExport.filter.team = ''
    UserModule.paginationParamsExport.filter.dealerarea = ''
    UserModule.paginationParamsExport.filter.dealername = ''
    UserModule.paginationParamsExport.filter.dealerCity = ''
    UserModule.paginationParamsExport.filter.dealerBranch = ''
    UserModule.paginationParamsExport.search = ''
    this.getUserData()
    this.getExport()
  }

  public get hasFilter(): boolean {
    if (
      UserReportModule.paginationParam.filter.team !== '' ||
      UserReportModule.paginationParam.filter.position !== '' ||
      UserReportModule.paginationParam.filter.dealercode !== '' ||
      UserReportModule.paginationParam.filter.dealergroup !== '' ||
      UserReportModule.paginationParam.filter.active !== '' ||
      UserReportModule.paginationParam.filter.statusRegistration !== '' ||
      UserReportModule.paginationParam.filter.typeSales !== '' ||
      UserReportModule.paginationParam.filter.dealerarea !== '' ||
      UserReportModule.paginationParam.filter.dealername !== '' ||
      UserReportModule.paginationParam.filter.city !== '' ||
      UserReportModule.paginationParam.filter.branch !== '' ||
      UserReportModule.paginationParam.filter.start !== '' ||
      UserReportModule.paginationParam.filter.end !== ''
    ) {
      return true
    } else {
      return false
    }
  }

  private onClearInputSearch: boolean = false

  private clearInputSearch() {
    if (this.onClearInputSearch === false) {
      this.onClearInputSearch = true
    } else {
      this.onClearInputSearch = false
    }
  }

  private onClearFilter: boolean = false
  private clearFilter() {
    if (this.onClearFilter === false) {
      this.onClearFilter = true
    } else {
      this.onClearFilter = false
    }
  }

  private get hasSearch() {
    return UserReportModule.paginationParam.filter.salescode === ''
      ? false
      : true
  }

  private get nameCharts() {
    return this.hasSearch === false && typeof this.dataCharts[0] !== 'undefined'
      ? 'Trend Total User Visit'
      : typeof this.UserActiveData[0] === 'undefined'
      ? `Trend User ${this.searchValue} Access Not Found`
      : `Trend User ${this.UserActiveData[0].salesCode} Access`
  }
}
